import React, { JSXElementConstructor, ReactElement } from 'react';
import Tooltip from 'carbon-react/lib/components/tooltip';

interface Props {
  disableTooltip: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: ReactElement<any, string | JSXElementConstructor<any>>;
  tooltipMessage?: string;
}
export const TooltipContainer = ({ disableTooltip, children, tooltipMessage }: Props) => {
  if (disableTooltip) {
    return <>{children}</>;
  }

  return <Tooltip message={tooltipMessage} position="bottom">{children}</Tooltip>;
};
